import Marquee from "react-fast-marquee";

const items = ["GASTRONOMIE", "RESTAURANTS", "PACKSHOT", "RECETTES", "NATURE MORTE", "ÉDITORIAL"];

export const EditorialMarquee = () => (
  <div className="py-8 border-y border-[#F4F0EB]/10 bg-[#141412] overflow-hidden">
    <Marquee speed={40} gradient={false} autoFill>
      {items.map((t, i) => (
        <span key={i} className="mx-10 font-serif-d text-3xl lg:text-5xl text-[#6E695E] flex items-center gap-10">
          {t} <span className="text-[#C88D51] text-xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
